import React, {Component} from 'react';
import PlannerOverviewScreen from "./PlannerOverviewScreen";

export default class PlannerOverviewScreen2 extends Component {
    render() {
        return (
            <PlannerOverviewScreen {...this.props}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlannerOverviewScreen2.js